import { ptBR } from '@/i18n/pt-BR';

/**
 * Vocabulário da trilha → frase da tela. // ux-neutrality:allow doc-comment
 *
 * O servidor devolve o código do fato; quem o traduz é o catálogo. A cobertura // ux-neutrality:allow doc-comment
 * do catálogo NÃO é confiada à revisão: `types/auditoria.ACOES_TRILHA` declara // ux-neutrality:allow doc-comment
 * tudo o que os seis ramos da trilha podem emitir, e // ux-neutrality:allow doc-comment
 * `tests/unit/test_e61_f4_paridade_catalogo_trilha.py` reprova ação ou origem // ux-neutrality:allow doc-comment
 * sem chave aqui — e chave órfã aqui também. // ux-neutrality:allow doc-comment
 * // ux-neutrality:allow doc-comment
 * O default existe só porque a resposta chega como texto. Ele diz que o fato // ux-neutrality:allow doc-comment
 * foi registrado, e não o código interno dele: devolver o código era o que // ux-neutrality:allow doc-comment
 * publicava `escritorio_criado` para o gestor (F-E61.F4-05). A linha não perde // ux-neutrality:allow doc-comment
 * valor de trilha — quando, quem e sobre o quê continuam na própria linha. // ux-neutrality:allow doc-comment
 *
 * Mora fora de `components/Admin/` porque as DUAS telas da trilha usam o mesmo // ux-neutrality:allow doc-comment
 * catálogo: o console da plataforma (E53.F7) e o módulo do banco (E61.F4). O // ux-neutrality:allow doc-comment
 * rótulo de AMBIENTE ficou no console (`components/Admin/ambiente_labels.ts`) — // ux-neutrality:allow doc-comment
 * é vocabulário de console, usado por outras três telas de lá, e a tela do // ux-neutrality:allow doc-comment
 * banco não mostra essa coluna. // ux-neutrality:allow doc-comment
 */
const _ORIGENS: Record<string, string> = {
  administracao: ptBR.trilha.origemAdministracao,
  assinatura: ptBR.trilha.origemAssinatura,
  medicao: ptBR.trilha.origemMedicao,
  requisicao: ptBR.trilha.origemRequisicao,
  edicao_laudo: ptBR.trilha.origemEdicaoLaudo,
  compartilhamento_laudo: ptBR.trilha.origemCompartilhamento,
};

const _ACOES: Record<string, string> = {
  cliente_criado: ptBR.trilha.acaoClienteCriado,
  // E61.F4.C06: o banco abre escritório (`banco_escritorios_service`) e o fato
  // ficou de fora do catálogo — o gestor viu o código na tela (F-E61.F4-05).
  escritorio_criado: ptBR.trilha.acaoEscritorioCriado,
  escritorio_vinculado: ptBR.trilha.acaoEscritorioVinculado,
  escritorio_desvinculado: ptBR.trilha.acaoEscritorioDesvinculado,
  escritorio_marcado_plataforma: ptBR.trilha.acaoEscritorioMarcadoPlataforma,
  escritorio_desmarcado_plataforma: ptBR.trilha.acaoEscritorioDesmarcadoPlataforma,
  usuario_criado: ptBR.trilha.acaoUsuarioCriado,
  papel_alterado: ptBR.trilha.acaoPapelAlterado,
  acesso_desativado: ptBR.trilha.acaoAcessoDesativado,
  acesso_reativado: ptBR.trilha.acaoAcessoReativado,
  laudo_assinado: ptBR.trilha.acaoLaudoAssinado,
  exame_entregue: ptBR.trilha.acaoExameEntregue,
  certificacao_requerida: ptBR.trilha.acaoCertificacaoRequerida,
  narrativa_editada: ptBR.trilha.acaoNarrativaEditada,
  lr_ajustado: ptBR.trilha.acaoLrAjustado,
  laudo_compartilhado: ptBR.trilha.acaoLaudoCompartilhado,
  // E61.F3: a ação nasceu com a trilha do banco e é a mais relevante para ele —
  // sem entrada aqui, a tela mostraria o código cru (E61.F4.T02).
  laudo_certificado_baixado: ptBR.trilha.acaoLaudoCertificadoBaixado,
  // E65.F3 (ADR-0069): único evento que o PRÓPRIO usuário grava sobre si. O
  // rótulo diz quem agiu porque a trilha também registra ações que terceiros
  // fazem sobre a conta — sem isso, "senha alterada" seria ambíguo justamente
  // onde a distinção importa.
  senha_trocada: ptBR.trilha.acaoSenhaTrocada,
  // E65.F6: a saída do arquivo ORIGINAL do caso — o que carrega a PII forense.
  // Vale para os dois ambientes, e é o banco quem lê os próprios eventos.
  documento_baixado: ptBR.trilha.acaoDocumentoBaixado,
  // E69.F1 (ADR-0072): o primeiro par que fala do ambiente inteiro — encerrar
  // desativa todo mundo no mesmo passo; reabrir não reativa ninguém.
  escritorio_encerrado: ptBR.trilha.acaoEscritorioEncerrado,
  escritorio_reaberto: ptBR.trilha.acaoEscritorioReaberto,
};

export function origemLabel(fonte: string): string {
  return _ORIGENS[fonte] ?? ptBR.trilha.origemDesconhecida;
}

export function acaoLabel(acao: string): string {
  return _ACOES[acao] ?? ptBR.trilha.acaoDesconhecida;
}
